// Version de l'application
export const APP_VERSION = '1.1.6';

// Clé pour le localStorage
const VERSION_KEY = 'quizvs_app_version';

/**
 * Vérifie si l'application a été mise à jour et force un rafraîchissement si nécessaire
 */
export function checkAppVersion(): boolean {
  try {
    const storedVersion = localStorage.getItem(VERSION_KEY);
    
    // Si c'est la première visite ou si la version a changé
    if (storedVersion !== APP_VERSION) {
      console.log(`🔄 Nouvelle version détectée: ${storedVersion} → ${APP_VERSION}`);
      
      // Mettre à jour la version stockée
      localStorage.setItem(VERSION_KEY, APP_VERSION);
      
      // Si ce n'est pas la première visite, forcer le rafraîchissement
      if (storedVersion !== null) {
        console.log('🔄 Rafraîchissement du cache...');
        
        // Vider le cache
        if ('caches' in window) {
          caches.keys().then(names => {
            names.forEach(name => {
              caches.delete(name);
            });
          });
        }
        
        // Recharger la page sans cache
        window.location.reload();
        return true;
      }
    }
    
    return false;
  } catch (error) {
    console.error('❌ Erreur lors de la vérification de version:', error);
    return false;
  }
}

/**
 * Obtenir la version actuelle de l'application
 */
export function getAppVersion(): string {
  return APP_VERSION;
}

/**
 * Forcer un rafraîchissement complet (utile pour le debug)
 */
export function forceRefresh(): void {
  localStorage.removeItem(VERSION_KEY);
  
  if ('caches' in window) {
    caches.keys().then(names => {
      names.forEach(name => {
        caches.delete(name);
      });
    });
  }
  
  window.location.reload();
}
